<template>
  <div class="limits">
    <Badge
      :label="`${rest} / ${limit}`"
      :appearance=" rest === 0 ? 'error' : 'success'"
      :status="true"
    />
    <div class="tooltip-container">
      <svg-icon
        :iconName="'kuiIconTooltipLarge'"
        :size="'24px'"
        class="tooltip-icon"
      />
      <div 
        class="tooltip"
        :class="['tooltip_right']"
      >
        <p class="body body_size_XS">Это счетчик твоих доступных запросов</p>
      </div>
    </div>
  </div>
</template>

<script>
import ParagraphSizeMedium from '@/components/UI/texts/paragraphs/ParagraphSizeMedium.vue';
import ParagraphSizeSmall from '@/components/UI/texts/paragraphs/ParagraphSizeSmall.vue';
import KazTooltip from '@/components/KazUI/atoms/tooltip'
import Badge from '@/components/KazUI/atoms/badge'

export default {
  name: 'limits-container',

  components: {
    ParagraphSizeMedium,
    ParagraphSizeSmall,
    Badge,
    KazTooltip
  },

  props: {
    rest: {
      type: Number,
      default: 2
    },
    limit: {
      type: Number,
      default: 2
    }
  },
  
  data() {
    return {
      windowWidth: 0,
    }
  },

  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  },

  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
}
</script>

<style scoped>
.limits {
  /* position: absolute;
  top: 32px;
  right: 32px; */
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  border-radius: 30px;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  visibility: hidden;
  width: 200px;
  padding: 12px 16px;
  color: #fff;
  text-align: center;
  background-color: var(--kaz-base-primary);
  border-radius: 12px;
  transform: translateY(-50%);
  transition: opacity 0.3s;
  opacity: 0;
  z-index: 1;
}

.tooltip_left {
  top: 50%;
  right: 110%;
}

.tooltip_right {
  top: 50%;
  left: 110%;
}

.body{
  color: var(--kaz-textIcons-day-text-01)
}

.tooltip::after {
  content: "";
  position: absolute;
}

.tooltip.tooltip_left::after {
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent;
  border-left-color: var(--kaz-base-primary);
}

.tooltip.tooltip_right::after {
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent;
  border-right-color: var(--kaz-base-primary);
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip-icon {
  cursor: help;
}

@media screen and (max-width: 992px) {
  .limits {
    top: 18px;
    right: 16px;
    background-color: var(--kaz-base-base-01);
  }
}
</style>
